import { alert } from "@components/common/Alert";
import mixpanel from "mixpanel-browser";
import { useEffect, useEffectEvent, useRef } from "react";

type Refetch = () => Promise<unknown>;

export function useRespondToTreatPurchaseComplete({
  refetchBalance,
  refetchDailySummaries,
}: {
  refetchBalance: Refetch;
  refetchDailySummaries: Refetch;
}) {
  const hasHandledRef = useRef(false);

  const handlePurchaseComplete = useEffectEvent(() => {
    refetchBalance();
    refetchDailySummaries();
    mixpanel.track("Treat Pack Purchase Success");
    alert("success", "Treats added to your balance 🎉");
  });

  useEffect(() => {
    if (hasHandledRef.current) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get("treatPurchaseComplete") !== "true") return;

    hasHandledRef.current = true;
    handlePurchaseComplete();

    params.delete("treatPurchaseComplete");
    const qs = params.toString();
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${qs ? `?${qs}` : ""}`,
    );
  }, []);
}
